<template>
  <div class="case">
    <div class="case-box">
      <div class="case-content">
        <div class="case-img-box">
          <img src="../assets/img/anli_001.png" />
        </div>
        <div class="case-text-box">
          <div class="case-text-one">客户案例</div>
          <div class="case-text-two">
            云征收助力数百家各地征收办、评估机构、征收服务代理
            公司实现信息化、透明化的征收模式
          </div>
        </div>
      </div>
    </div>
    <el-main
      v-loading="pictLoading"
      element-loading-text="加载中"
      class="attachment-information-right"
      element-loading-spinner="el-icon-loading"
    >
      <div class="case-content-box">
        <div class="case-content-list">
          <div
            class="case-content-one"
            v-for="(item,index) in caseList"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="case-content-img" v-if="item.imageUrl">
              <img :src="item.imageUrl" />
            </div>
            <div class="case-content-none" v-else>
              <img src="../assets/img/u25861.png" />
            </div>
            <div class="case-title-box">
              <div class="case-content-title">{{item.title}}</div>
              <div class="case-content-date">{{item.createTime}}</div>
            </div>
          </div>
        </div>
        <div class="page-box">
          <el-pagination
            background
            @current-change="handleSizeChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-main>
    <router-view></router-view>
  </div>
</template>
<script>
import { queryOpertionPublicityByClient } from '../api/publicinquiry.api.js';
export default {
  data() {
    return {
      caseList: [],
      total: 0,
      pageNo: 1,
      pageSize: 6,
      pictLoading: false
    };
  },
  methods: {
    getList() {
      this.pictLoading = true;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: 2
      };
      queryOpertionPublicityByClient(params).then(res => {
        this.total = res.data.count;
        this.caseList = res.data.list;
        this.pictLoading = false;
      });
    },
    handleSizeChange(page) {
      this.pictLoading = false;
      this.pageNo = page;
      this.getList();
    },
    toDetail(item) {
      this.$router.push({
        name: 'caseDetail',
        params: {
          Id: item.id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style>
.case {
  width: 100%;
}
.case-box {
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.case-img-box img {
  width: 100%;
  margin-top: 30px;
}
.case-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.case-text-box,
.case-img-box {
  width: 50%;
}
.case-text-one {
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
  margin-top: 150px;
}
.case-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
  line-height: 36px;
}
.case-content-box {
  width: 1500px;
  margin: auto;
}
.case-content-list {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow: hidden;
}
.case-content-one {
  width: 470px;
  height: 500px;
  margin-top: 50px;
  border-radius: 20px;
  -moz-box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
  -webkit-box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
  box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
  border: 1px solid rgba(215, 215, 215, 1);
  cursor: pointer;
}
.case-content-one:nth-child(2),
.case-content-one:nth-child(3),
.case-content-one:nth-child(5),
.case-content-one:nth-child(6) {
  margin-left: 40px;
}
.case-content-img img {
  width: 470px;
  height: 380px;
}
.case-content-none {
  width: 470px;
  height: 380px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}
.case-content-none img {
  width: 260px;
  height: 260px;
}
.case-content-title {
  padding: 0 24px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #000000;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.case-content-date {
  font-size: 14px;
  text-align: right;
  color: #666666;
  padding: 0 24px;
  margin-top: 30px;
}
.page-box {
  text-align: center;
  margin-top: 30px;
  padding-bottom: 30px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #08c0b9;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #08c0b9;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #08c0b9;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #08c0b9;
  color: #fff;
}
.case-content-one:hover .case-content-title {
  color: #08c0b9;
}
.el-icon-loading {
  color: #08c0b9 !important;
}
.el-loading-spinner .el-loading-text {
  color: #08c0b9 !important;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .case-content,
  .case-content-box {
    width: 1200px !important;
  }
  /* .case-text-box {
    margin-left: 190px !important;
  } */
  .case-content-one {
    width: 30% !important;
    height: 35% !important;
  }
  .case-content-one img {
    width: 100% !important;
  }
  .case-content-one:nth-child(2),
  .case-content-one:nth-child(3),
  .case-content-one:nth-child(5),
  .case-content-one:nth-child(6) {
    margin-left: 49px !important;
  }
  .case-title-box {
    height: 102px !important;
  }
  .case-content-date {
    height: 16px !important;
    margin-top: 15px !important;
  }
  .case-content-title {
    height: 56px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/case.vue